import type { IconDef } from '../types';

export const soundwave: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M4.47748 7.32602C4.47748 6.66568 3.92288 6.13037 3.23874 6.13037C2.5546 6.13037 2 6.66568 2 7.32602L2 16.6739C2 17.3342 2.5546 17.8695 3.23874 17.8695C3.92288 17.8695 4.47748 17.3342 4.47748 16.6739L4.47748 7.32602Z',
    },
    {
      d: 'M10.3447 1.19565C10.3447 0.535312 9.79006 0 9.10593 0C8.42179 0 7.86719 0.535312 7.86719 1.19565L7.86719 22.8043C7.86719 23.4647 8.42179 24 9.10593 24C9.79006 24 10.3447 23.4647 10.3447 22.8043L10.3447 1.19565Z',
    },
    {
      d: 'M16.1782 4.61948C16.1782 3.95914 15.6236 3.42383 14.9394 3.42383C14.2553 3.42383 13.7007 3.95914 13.7007 4.61948L13.7007 19.3804C13.7007 20.0407 14.2553 20.576 14.9394 20.576C15.6236 20.576 16.1782 20.0407 16.1782 19.3804L16.1782 4.61948Z',
    },
    {
      d: 'M21.9999 9.49985C21.9999 8.83951 21.4453 8.3042 20.7612 8.3042C20.0771 8.3042 19.5225 8.83951 19.5225 9.49985L19.5225 14.4999C19.5225 15.1602 20.0771 15.6955 20.7612 15.6955C21.4453 15.6955 21.9999 15.1602 21.9999 14.4999V9.49985Z',
    },
  ],
};
